import React from 'react';
import { Col } from 'react-bootstrap';
import { GroupItem, BtnGroupContainer } from '../../style';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { MdOutlineCancel } from 'react-icons/md';
import { FaEraser } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';

interface PeriodOption {
  value: number;
  label: string;
}

interface PropsComponent {
  tipoPeriodo: PeriodOption;
  setTipoPeriodo: (value: PeriodOption) => void;
  getTitulosAPagar: () => void;
  cancelSearch: () => void;
  clearForm: () => void;
  isFetching: boolean;
}
export const GroupButtons: React.FC<PropsComponent> = ({
  tipoPeriodo,
  setTipoPeriodo,
  getTitulosAPagar,
  clearForm,
  cancelSearch,
  isFetching,
}) => {
  const periodos: PeriodOption[] = [
    { value: 0, label: 'Atrasada' },
    { value: 1, label: 'Hoje' },
    { value: 2, label: 'Amanhã' },
    { value: 3, label: '5 dias' },
    { value: 4, label: '15 dias' },
    { value: 5, label: '30 dias' },
    { value: 6, label: '60 dias' },
  ];
  return (
    <>
      <Col md={6} sm={12}>
        <GroupItem style={{ height: 'auto', marginTop: '20px' }}>
          <label htmlFor="toggle-controlled" className="label">
            Próxima Venda
          </label>

          <BtnGroupContainer>
            {periodos.map((periodo, index) => (
              <CustomButtonNovo
                key={periodo.value}
                className={
                  tipoPeriodo.value === periodo.value
                    ? 'btn-group btn-group-active'
                    : 'btn-group'
                }
                disabled={isFetching}
                type="button"
                onClick={() => setTipoPeriodo(periodo)}
                style={{
                  height: '37px',
                  minWidth: '110px',
                  borderRadius:
                    index === 0
                      ? '4px 0px 0px 4px'
                      : index === periodos.length - 1
                      ? '0px 4px 4px 0px'
                      : '0px',
                }}
              >
                {periodo.label}
              </CustomButtonNovo>
            ))}
          </BtnGroupContainer>
        </GroupItem>
      </Col>
      <Col>
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '-40px',
            }}
          >
            <CustomButtonNovo
              onClick={getTitulosAPagar}
              label="Pesquisar"
              disabled={isFetching}
              icon={IoIosSearch}
            />
            <CustomButtonNovo
              variant="cancel"
              disabled={false}
              onClick={cancelSearch}
              label="Cancelar"
              icon={MdOutlineCancel}
            />
            <CustomButtonNovo
              variant="clear"
              disabled={isFetching}
              onClick={clearForm}
              label="Limpar"
              icon={FaEraser}
            />
          </div>
        </>
      </Col>
    </>
  );
};
